const identifyIntervalsData = [
  {
    id: 1, 
    soundSequences: ["Unison", "Minor 2nd"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 2, 
    soundSequences: ["Unison", "Minor 2nd"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 3, 
    soundSequences: ["Unison", "Minor 2nd"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 4, 
    soundSequences: ["Major 2nd", "Minor 3rd"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 5, 
    soundSequences: ["Major 2nd", "Minor 3rd"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 6, 
    soundSequences: ["Major 2nd", "Minor 3rd"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 7, 
    soundSequences: ["Unison", "Minor 2nd", "Major 2nd", "Minor 3rd"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 8, 
    soundSequences: ["Unison", "Minor 2nd", "Major 2nd", "Minor 3rd"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 9, 
    soundSequences: ["Unison", "Minor 2nd", "Major 2nd", "Minor 3rd"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 10, 
    soundSequences: ["Major 3rd","Perfect 4th"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 11, 
    soundSequences: ["Major 3rd","Perfect 4th"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 12, 
    soundSequences: ["Major 3rd","Perfect 4th"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 13, 
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 14, 
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 15, 
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 16, 
    soundSequences: ["Diminished 5th","Perfect 5th"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 17, 
    soundSequences: ["Diminished 5th","Perfect 5th"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 18, 
    soundSequences: ["Diminished 5th","Perfect 5th"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 19, 
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 20, 
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 21, 
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 22, 
    soundSequences: ["Minor 6th","Major 6th"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 23, 
    soundSequences: ["Minor 6th","Major 6th"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 24, 
    soundSequences: ["Minor 6th","Major 6th"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 25, 
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 26, 
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 27, 
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 28, 
    soundSequences: ["Minor 7th","Major 7th"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 29, 
    soundSequences: ["Minor 7th","Major 7th"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 30, 
    soundSequences: ["Minor 7th","Major 7th"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 31, 
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th","Minor 7th","Major 7th"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 32, 
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th","Minor 7th","Major 7th"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 33, 
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th","Minor 7th","Major 7th"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 34, 
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th","Minor 7th","Major 7th","Octave"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 35, 
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th","Minor 7th","Major 7th","Octave"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 36, 
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th","Minor 7th","Major 7th","Octave"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  }
];

const indentifyChordsData = [
    {
      id: 1,
      soundSequences: ["Major","Minor"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 2,
      soundSequences: ["Major","Minor"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 3,
      soundSequences: ["Major","Minor"],
      harmony: "harmonic",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 4,
      soundSequences: ["Augmented","Diminished"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 5,
      soundSequences: ["Augmented","Diminished"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 6,
      soundSequences: ["Augmented","Diminished"],
      harmony: "harmonic",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 7,
      soundSequences: ["Major","Minor","Augmented","Diminished"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 8,
      soundSequences: ["Major","Minor","Augmented","Diminished"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 9,
      soundSequences: ["Major","Minor","Augmented","Diminished"],
      harmony: "harmonic",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 10,
      soundSequences: ["Sus2","Sus4"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 11,
      soundSequences: ["Sus2","Sus4"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 12,
      soundSequences: ["Sus2","Sus4"],
      harmony: "harmonic",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 13,
      soundSequences: ["Major","Minor","Augmented","Diminished","Sus2","Sus4"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 14,
      soundSequences: ["Major","Minor","Augmented","Diminished","Sus2","Sus4"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 15,
      soundSequences: ["Major","Minor","Augmented","Diminished","Sus2","Sus4"],
      harmony: "harmonic",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 16,
      soundSequences: ["7","Maj7"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 17,
      soundSequences: ["7","Maj7"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 18,
      soundSequences: ["7","Maj7"],
      harmony: "harmonic",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 19,
      soundSequences: ["7","Maj7","m7"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 20,
      soundSequences: ["7","Maj7","m7"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 21,
      soundSequences: ["7","Maj7","m7"],
      harmony: "harmonic",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 22,
      soundSequences: ["6","m6"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 23,
      soundSequences: ["6","m6"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 24,
      soundSequences: ["6","m6"],
      harmony: "harmonic",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 25,
      soundSequences: ["7","Maj7","m7","6","m6"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 26,
      soundSequences: ["7","Maj7","m7","6","m6"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 27,
      soundSequences: ["7","Maj7","m7","6","m6"],
      harmony: "harmonic",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 28,
      soundSequences: ["m7b5","Dim7"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 29,
      soundSequences: ["m7b5","Dim7"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 30,
      soundSequences: ["m7b5","Dim7"],
      harmony: "harmonic",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 31,
      soundSequences: ["7","Maj7","m7","m7b5","Dim7","6","m6"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 32,
      soundSequences: ["7","Maj7","m7","m7b5","Dim7","6","m6"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 33,
      soundSequences: ["7","Maj7","m7","m7b5","Dim7","6","m6"],
      harmony: "harmonic",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 34,
      soundSequences: ["7(b5)","7(#5)"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 35,
      soundSequences: ["7(b5)","7(#5)"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 36,
      soundSequences: ["7(b5)","7(#5)"],
      harmony: "harmonic",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 37,
      soundSequences: ["7","Maj7","m7","m7b5","Dim7","7(b5)","7(#5)","6","m6"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 38,
      soundSequences: ["7","Maj7","m7","m7b5","Dim7","7(b5)","7(#5)","6","m6"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 39,
      soundSequences: ["7","Maj7","m7","m7b5","Dim7","7(b5)","7(#5)","6","m6"],
      harmony: "harmonic",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 40,
      soundSequences: ["m(maj7)","sus4(7)"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 41,
      soundSequences: ["m(maj7)","sus4(7)"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 42,
      soundSequences: ["m(maj7)","sus4(7)"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 43,
      soundSequences: ["7","Maj7","m7","m7b5","Dim7","7(b5)","7(#5)","m(maj7)","sus4(7)","6","m6"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 44,
      soundSequences: ["7","Maj7","m7","m7b5","Dim7","7(b5)","7(#5)","m(maj7)","sus4(7)","6","m6"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 45,
      soundSequences: ["7","Maj7","m7","m7b5","Dim7","7(b5)","7(#5)","m(maj7)","sus4(7)","6","m6"],
      harmony: "harmonic",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 46,
      soundSequences: ["Minor","Augmented","Diminished","Sus2","Sus4","7","Maj7","m7","m7b5","Dim7","7(b5)","7(#5)","m(maj7)","sus4(7)","6","m6"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 47,
      soundSequences: ["Minor","Augmented","Diminished","Sus2","Sus4","7","Maj7","m7","m7b5","Dim7","7(b5)","7(#5)","m(maj7)","sus4(7)","6","m6"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 48,
      soundSequences: ["Minor","Augmented","Diminished","Sus2","Sus4","7","Maj7","m7","m7b5","Dim7","7(b5)","7(#5)","m(maj7)","sus4(7)","6","m6"],
      harmony: "harmonic",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 49,
      soundSequences: ["Maj9","9"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 50,
      soundSequences: ["Maj9","9"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 51,
      soundSequences: ["Maj9","9"],
      harmony: "harmonic",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 52,
      soundSequences: ["7(b9)","7(#9)","m9"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 53,
      soundSequences: ["7(b9)","7(#9)","m9"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 54,
      soundSequences: ["7(b9)","7(#9)","m9"],
      harmony: "harmonic",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 55,
      soundSequences: ["Maj9","7(b9)","9","7(#9)","m9"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 56,
      soundSequences: ["Maj9","7(b9)","9","7(#9)","m9"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 57,
      soundSequences: ["Maj9","7(b9)","9","7(#9)","m9"],
      harmony: "harmonic",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 58,
      soundSequences: ["Major","Minor","Augmented","Diminished","Sus2","Sus4","7","Maj7","m7","m7b5","Dim7","7(b5)","7(#5)","m(maj7)","sus4(7)","6","m6","Maj9","7(b9)","9","7(#9)","m9"],
      harmony: "ascending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 59,
      soundSequences: ["Major","Minor","Augmented","Diminished","Sus2","Sus4","7","Maj7","m7","m7b5","Dim7","7(b5)","7(#5)","m(maj7)","sus4(7)","6","m6","Maj9","7(b9)","9","7(#9)","m9"],
      harmony: "descending",
      randomRoot: true,
      numberOfQuestions: 20
    },
    {
      id: 60,
      soundSequences: ["Major","Minor","Augmented","Diminished","Sus2","Sus4","7","Maj7","m7","m7b5","Dim7","7(b5)","7(#5)","m(maj7)","sus4(7)","6","m6","Maj9","7(b9)","9","7(#9)","m9"],
      harmony: "harmonic",
      randomRoot: true,
      numberOfQuestions: 20
    }
]

const compareIntervalSizesData  = [
  {
    id: 1,
    soundSequences: ["Unison","Octave"],
    harmony: "ascending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 2,
    soundSequences: ["Unison","Octave"],
    harmony: "descending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 3,
    soundSequences: ["Unison","Octave"],
    harmony: "harmonic",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 4,
    soundSequences: ["Unison","Octave"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 5,
    soundSequences: ["Unison","Octave"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 6,
    soundSequences: ["Unison","Octave"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 7,
    soundSequences: ["Minor 2nd","Major 7th"],
    harmony: "ascending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 8,
    soundSequences: ["Minor 2nd","Major 7th"],
    harmony: "descending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 9,
    soundSequences: ["Minor 2nd","Major 7th"],
    harmony: "harmonic",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 10,
    soundSequences: ["Minor 2nd","Major 7th"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 11,
    soundSequences: ["Minor 2nd","Major 7th"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 12,
    soundSequences: ["Minor 2nd","Major 7th"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 13,
    soundSequences: ["Major 2nd","Minor 7th"],
    harmony: "ascending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 14,
    soundSequences: ["Major 2nd","Minor 7th"],
    harmony: "descending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 15,
    soundSequences: ["Major 2nd","Minor 7th"],
    harmony: "harmonic",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 16,
    soundSequences: ["Major 2nd","Minor 7th"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 17,
    soundSequences: ["Major 2nd","Minor 7th"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 18,
    soundSequences: ["Major 2nd","Minor 7th"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 19,
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 7th","Major 7th","Octave"],
    harmony: "ascending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 20,
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 7th","Major 7th","Octave"],
    harmony: "descending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 21,
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 7th","Major 7th","Octave"],
    harmony: "harmonic",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 22,
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 7th","Major 7th","Octave"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 23,
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 7th","Major 7th","Octave"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 24,
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 7th","Major 7th","Octave"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 25,
    soundSequences: ["Minor 3rd","Major 6th"],
    harmony: "ascending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 26,
    soundSequences: ["Minor 3rd","Major 6th"],
    harmony: "descending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 27,
    soundSequences: ["Minor 3rd","Major 6th"],
    harmony: "harmonic",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 28,
    soundSequences: ["Minor 3rd","Major 6th"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 29,
    soundSequences: ["Minor 3rd","Major 6th"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 30,
    soundSequences: ["Minor 3rd","Major 6th"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 31,
    soundSequences: ["Major 3rd","Minor 6th"],
    harmony: "ascending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 32,
    soundSequences: ["Major 3rd","Minor 6th"],
    harmony: "descending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 33,
    soundSequences: ["Major 3rd","Minor 6th"],
    harmony: "harmonic",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 34,
    soundSequences: ["Major 3rd","Minor 6th"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 35,
    soundSequences: ["Major 3rd","Minor 6th"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 36,
    soundSequences: ["Major 3rd","Minor 6th"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 37,
    soundSequences: ["Perfect 4th","Diminished 5th","Perfect 5th"],
    harmony: "ascending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 38,
    soundSequences: ["Perfect 4th","Diminished 5th","Perfect 5th"],
    harmony: "descending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 39,
    soundSequences: ["Perfect 4th","Diminished 5th","Perfect 5th"],
    harmony: "harmonic",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 40,
    soundSequences: ["Perfect 4th","Diminished 5th","Perfect 5th"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 41,
    soundSequences: ["Perfect 4th","Diminished 5th","Perfect 5th"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 42,
    soundSequences: ["Perfect 4th","Diminished 5th","Perfect 5th"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 43,
    soundSequences: ["Minor 2nd","Major 2nd"],
    harmony: "ascending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 44,
    soundSequences: ["Minor 2nd","Major 2nd"],
    harmony: "descending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 45,
    soundSequences: ["Minor 2nd","Major 2nd"],
    harmony: "harmonic",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 46,
    soundSequences: ["Minor 2nd","Major 2nd"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 47,
    soundSequences: ["Minor 2nd","Major 2nd"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 48,
    soundSequences: ["Minor 2nd","Major 2nd"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 49,
    soundSequences: ["Minor 2nd","Major 2nd","Minor 3rd","Major 3rd"],
    harmony: "ascending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 50,
    soundSequences: ["Minor 2nd","Major 2nd","Minor 3rd","Major 3rd"],
    harmony: "descending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 51,
    soundSequences: ["Minor 2nd","Major 2nd","Minor 3rd","Major 3rd"],
    harmony: "harmonic",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 52,
    soundSequences: ["Minor 2nd","Major 2nd","Minor 3rd","Major 3rd"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 53,
    soundSequences: ["Minor 2nd","Major 2nd","Minor 3rd","Major 3rd"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 54,
    soundSequences: ["Minor 2nd","Major 2nd","Minor 3rd","Major 3rd"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 55,
    soundSequences: ["Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th"],
    harmony: "ascending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 56,
    soundSequences: ["Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th"],
    harmony: "descending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 57,
    soundSequences: ["Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th"],
    harmony: "harmonic",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 58,
    soundSequences: ["Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 59,
    soundSequences: ["Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 60,
    soundSequences: ["Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 61,
    soundSequences: ["Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th","Minor 7th"],
    harmony: "ascending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 62,
    soundSequences: ["Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th","Minor 7th"],
    harmony: "descending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 63,
    soundSequences: ["Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th","Minor 7th"],
    harmony: "harmonic",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 64,
    soundSequences: ["Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th","Minor 7th"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 65,
    soundSequences: ["Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th","Minor 7th"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 66,
    soundSequences: ["Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th","Minor 7th"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 67,
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th","Minor 7th","Octave"],
    harmony: "ascending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 68,
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th","Minor 7th","Octave"],
    harmony: "descending",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 69,
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th","Minor 7th","Octave"],
    harmony: "harmonic",
    randomRoot: false,
    numberOfQuestions: 20
  },
  {
    id: 70,
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th","Minor 7th","Octave"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 71,
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th","Minor 7th","Octave"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 72,
    soundSequences: ["Unison","Minor 2nd","Major 2nd","Minor 3rd","Major 3rd","Perfect 4th","Diminished 5th","Perfect 5th","Minor 6th","Major 6th","Minor 7th","Octave"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  }
]

const identifyScalesData = [
  {
    id: 1,
    soundSequences: ["Major Pentatonic","Minor Pentatonic"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 2,
    soundSequences: ["Major Pentatonic","Minor Pentatonic"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 3,
    soundSequences: ["Ionian","Lydian","Mixoydian"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 4,
    soundSequences: ["Ionian","Lydian","Mixoydian"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 5,
    soundSequences: ["Dorian","Aeolian"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 6,
    soundSequences: ["Dorian","Aeolian"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 7,
    soundSequences: ["Phrygian","Locrian"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 8,
    soundSequences: ["Phrygian","Locrian"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 9,
    soundSequences: ["Major Pentatonic","Minor Pentatonic","Ionian","Dorian","Phrygian","Lydian","Mixoydian","Aeolian","Locrian"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 10,
    soundSequences: ["Major Pentatonic","Minor Pentatonic","Ionian","Dorian","Phrygian","Lydian","Mixoydian","Aeolian","Locrian"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 11,
    soundSequences: ["Harmonic Minor","Melodic Minor"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 12,
    soundSequences: ["Harmonic Minor","Melodic Minor"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 13,
    soundSequences: ["Lydian (#5)","Lydian (b7)","Mixolydian (b13)"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 14,
    soundSequences: ["Lydian (#5)","Lydian (b7)","Mixolydian (b13)"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 15,
    soundSequences: ["Wholetone","Diminished (1-1/2)","Diminished (1/2-1)"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 16,
    soundSequences: ["Wholetone","Diminished (1-1/2)","Diminished (1/2-1)"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 17,
    soundSequences: ["Harmonic Minor","Melodic Minor","Lydian (#5)","Lydian (b7)","Mixolydian (b13)","Wholetone","Locrian (#2)","Diminished (1-1/2)","Diminished (1/2-1)"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 18,
    soundSequences: ["Harmonic Minor","Melodic Minor","Lydian (#5)","Lydian (b7)","Mixolydian (b13)","Wholetone","Locrian (#2)","Diminished (1-1/2)","Diminished (1/2-1)"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 19,
    soundSequences: ["Altered","Persian"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 20,
    soundSequences: ["Altered","Persian"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 21,
    soundSequences: ["Phrygian (#6)","Dorian (#4)","Mixolydian (b9,b13)"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 22,
    soundSequences: ["Phrygian (#6)","Dorian (#4)","Mixolydian (b9,b13)"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 23,
    soundSequences: ["Ionian (#5)","Lydian (#2)"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 24,
    soundSequences: ["Ionian (#5)","Lydian (#2)"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 25,
    soundSequences: ["Altered","Phrygian (#6)","Dorian (#4)","Mixolydian (b9,b13)","Ionian (#5)","Lydian (#2)","Persian"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 26,
    soundSequences: ["Altered","Phrygian (#6)","Dorian (#4)","Mixolydian (b9,b13)","Ionian (#5)","Lydian (#2)","Persian"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 27,
    soundSequences: ["Major Pentatonic","Minor Pentatonic","Ionian","Dorian","Phrygian","Lydian","Mixoydian","Aeolian","Locrian","Harmonic Minor","Lydian (#5)","Lydian (b7)","Mixolydian (b13)","Wholetone","Locrian (#2)","Diminished (1-1/2)","Diminished (1/2-1)","Altered","Phrygian (#6)","Dorian (#4)","Mixolydian (b9,b13)","Ionian (#5)","Lydian (#2)","Persian"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20,
  },
  {
    id: 28,
    soundSequences: ["Major Pentatonic","Minor Pentatonic","Ionian","Dorian","Phrygian","Lydian","Mixoydian","Aeolian","Locrian","Harmonic Minor","Lydian (#5)","Lydian (b7)","Mixolydian (b13)","Wholetone","Locrian (#2)","Diminished (1-1/2)","Diminished (1/2-1)","Altered","Phrygian (#6)","Dorian (#4)","Mixolydian (b9,b13)","Ionian (#5)","Lydian (#2)","Persian"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20,
  }  
]

const identifyChordInversionsData = [
  {
    id: 1,
    soundSequences: ["Major"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 2,
    soundSequences: ["Major"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 3,
    soundSequences: ["Major"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 4,
    soundSequences: ["Minor"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 5,
    soundSequences: ["Minor"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 6,
    soundSequences: ["Minor"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 7,
    soundSequences: ["Diminished"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 8,
    soundSequences: ["Diminished"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 9,
    soundSequences: ["Diminished"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 10,
    soundSequences: ["Major","Minor","Diminished"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 11,
    soundSequences: ["Major","Minor","Diminished"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 12,
    soundSequences: ["Major","Minor","Diminished"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 13,
    soundSequences: ["7"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 14,
    soundSequences: ["7"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 15,
    soundSequences: ["7"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 16,
    soundSequences: ["Maj7"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 17,
    soundSequences: ["Maj7"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 18,
    soundSequences: ["Maj7"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 19,
    soundSequences: ["m7"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 20,
    soundSequences: ["m7"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 21,
    soundSequences: ["m7"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 22,
    soundSequences: ["m7b5"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 23,
    soundSequences: ["m7b5"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 24,
    soundSequences: ["m7b5"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 25,
    soundSequences: ["7","Maj7","m7","m7b5"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 26,
    soundSequences: ["7","Maj7","m7","m7b5"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 27,
    soundSequences: ["7","Maj7","m7","m7b5"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 28,
    soundSequences: ["7(#5)"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 29,
    soundSequences: ["7(#5)"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 30,
    soundSequences: ["7(#5)"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 31,
    soundSequences: ["m(maj7)"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 32,
    soundSequences: ["m(maj7)"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 33,
    soundSequences: ["m(maj7)"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 34,
    soundSequences: ["sus4(7)"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 35,
    soundSequences: ["sus4(7)"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 36,
    soundSequences: ["sus4(7)"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 37,
    soundSequences: ["m(maj7)","sus4(7)"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 38,
    soundSequences: ["m(maj7)","sus4(7)"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 39,
    soundSequences: ["m(maj7)","sus4(7)"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 40,
    soundSequences: ["6"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 41,
    soundSequences: ["6"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 42,
    soundSequences: ["6"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 43,
    soundSequences: ["m6"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 44,
    soundSequences: ["m6"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 45,
    soundSequences: ["m6"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 46,
    soundSequences: ["6","m6"],
    harmony: "ascending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 47,
    soundSequences: ["6","m6"],
    harmony: "descending",
    randomRoot: true,
    numberOfQuestions: 20
  },
  {
    id: 48,
    soundSequences: ["6","m6"],
    harmony: "harmonic",
    randomRoot: true,
    numberOfQuestions: 20
  }
]

export {compareIntervalSizesData, indentifyChordsData, identifyIntervalsData, identifyScalesData, identifyChordInversionsData};
